import SearchOptions from './SearchOptions';

export default class RecentSearch {

    public constructor(public readonly text: string, public readonly options: SearchOptions) {
    }

    public getId(): string {
        return JSON.stringify([this.text, this.options]);
    }
}
